import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="schedule-entries--cell"
export default class extends Controller {
  static outlets = ["schedule-entries--week-calendar"];
  static WEEKEND_DAYS = [0, 6];

  createEntry(event) {
    if (this.isClickOnExistingEntry(event)) return;

    const { projectPartId, date, effectiveAttendanceRule, sharable, holiday, onSite } = this.extractDataFromEvent(event);

    if (this.isWeekend(date) && sharable === "true") {
      this.showWeekendAlert();
      return;
    }

    if (holiday === "true" && onSite === "false") {
      this.showHolidayAlert();
      return;
    }

    if (effectiveAttendanceRule) {
      this.navigateToNewEntryForm(projectPartId, date, sharable);
    } else {
      alert("区分が未設定です。「勤怠ルール」と「勤怠ルール適用」を設定してください。");
    }
  }

  isClickOnExistingEntry(event) {
    return event.target.closest(".schedule-entry") !== null;
  }

  extractDataFromEvent(event) {
    const { projectPartId, date, effectiveAttendanceRule, sharable, holiday, onSite } = event.currentTarget.dataset;
    return { projectPartId, date, effectiveAttendanceRule, sharable, holiday, onSite };
  }

  isWeekend(dateString) {
    const date = new Date(dateString);
    return this.constructor.WEEKEND_DAYS.includes(date.getDay());
  }

  showWeekendAlert() {
    alert("休日（土日）にはスケジュールを設定できません。");
  }

  showHolidayAlert() {
    alert("祝日には有給休暇のスケジュールを設定することはできません。");
  }

  navigateToNewEntryForm(projectPartId, date, sharable) {
    const url = this.buildNewEntryUrl(projectPartId, date, sharable);
    Turbo.visit(url.toString(), { frame: "modal" });
  }

  buildNewEntryUrl(projectPartId, date, sharable) {
    const url = new URL("/schedule_entries/new", window.location.origin);
    
    if (this.hasScheduleEntriesWeekCalendarOutlet) {
      const searchParams = this.scheduleEntriesWeekCalendarOutlet.getSearchFormParams();
      searchParams.forEach((value, key) => {
        if (value) url.searchParams.set(key, value);
      });

      const weekStart = this.scheduleEntriesWeekCalendarOutlet.getCurrentWeekStart();
      url.searchParams.set("week_start", this.formatDate(weekStart));
    } else {
      // Fallback to window search if outlet is not available
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, key) => {
        url.searchParams.set(key, value);
      });
    }

    url.searchParams.set("project_part_id", projectPartId);
    url.searchParams.set("date", date);
    url.searchParams.set("sharable", sharable);

    return url;
  }

  formatDate(date) {
    return date.toISOString().split('T')[0];
  }
}
